export const MODULE_OPENED = 'TRACK_MODULE_OPENED';
export const MODULE_FINISHED = 'TRACK_MODULE_FINISHED';
export const MODULE_ATTEMPT = 'STORE_MODULE_ATTEMPT_UUID';
export const CLEAR_MODULE_ATTEMPT = 'CLEAR_MODULE_ATTEMPT_UUID';